var _ellipse, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 113,
    viewBox: "0 0 164 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.52 42.9695)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2630_13229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 25,
    width: 89,
    height: 60,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 25.25,
    width: 88.5,
    height: 59.5,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7917 68.875H94.3493C95.8465 68.875 96.5951 68.875 97.0078 68.5629C97.3673 68.2909 97.5898 67.8752 97.6166 67.4253C97.6475 66.9087 97.2322 66.2859 96.4017 65.0401L91.7607 58.0786C91.0745 57.0493 90.7314 56.5346 90.2989 56.3553C89.9208 56.1985 89.4959 56.1985 89.1178 56.3553C88.6853 56.5346 88.3422 57.0493 87.656 58.0786L86.5087 59.7996M92.7917 68.875L80.9448 51.7628C80.2634 50.7787 79.9228 50.2866 79.4972 50.1136C79.125 49.9623 78.7084 49.9623 78.3361 50.1136C77.9106 50.2866 77.5699 50.7787 76.8886 51.7628L67.7214 65.0043C66.8534 66.2581 66.4194 66.885 66.4441 67.4064C66.4656 67.8604 66.6864 68.2818 67.0475 68.558C67.4621 68.875 68.2246 68.875 69.7495 68.875H92.7917ZM95.875 45.75C95.875 48.3044 93.8043 50.375 91.25 50.375C88.6957 50.375 86.625 48.3044 86.625 45.75C86.625 43.1957 88.6957 41.125 91.25 41.125C93.8043 41.125 95.875 43.1957 95.875 45.75Z",
    stroke: "#C4D9FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9455 51.7628L67.7783 65.0043C66.9103 66.2581 66.4763 66.885 66.501 67.4064C66.5225 67.8604 66.7433 68.2818 67.1044 68.558C67.519 68.875 68.2814 68.875 69.8064 68.875H92.8486L81.0016 51.7628C80.3203 50.7787 79.9796 50.2866 79.5541 50.1136C79.1819 49.9623 78.7652 49.9623 78.393 50.1136C77.9675 50.2866 77.6268 50.7787 76.9455 51.7628Z",
    fill: "#C4D9FE",
    stroke: "#C4D9FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.009 33.9474V77.0531M119.605 19.5755H47.4614M30.9912 33.9474V77.0531M21.5 91.4208H30.9912V101M119.605 91.4208H47.4614M133.009 10V19.579H142.5M142.5 91.4208H133.009V101M30.9912 10V19.579H21.5",
    stroke: "#E2E2E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2630_13229",
    x: 33.5,
    y: 25,
    width: 97,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2630_13229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2630_13229",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetScreen);
export default __webpack_public_path__ + "static/media/getScreen.a609dde3.svg";
export { ForwardRef as ReactComponent };